import { parseKey } from '../music/key';
import { pitchName } from '../music/pitch';
import { voiceProgression } from '../music/voicing';
import type { ProtoEvent } from './types';

/** Fenaroli-style rule of the octave in C major, ascending then descending. */
export const RULE_SYMBOLS = ['I', 'V43', 'I6', 'ii65', 'V', 'IV6', 'V65', 'I', 'V6', 'V43/V', 'V', 'V42', 'I6', 'V43', 'I'];
/** The same bass with a root-position triad on every step. */
export const PLAIN_SYMBOLS = ['I', 'ii', 'iii', 'IV', 'V', 'vi', 'viio', 'I', 'viio', 'vi', 'V', 'IV', 'iii', 'ii', 'I'];
export const RULE_BASS = [48, 50, 52, 53, 55, 57, 59, 60, 59, 57, 55, 53, 52, 50, 48];

function realize(symbols: string[]): ProtoEvent[] {
  const voiced = voiceProgression(symbols, parseKey('C'), { bass: RULE_BASS });
  return voiced.map((v, i) => ({
    rn: v.chord.symbol,
    dur: i === 7 ? 2 : i === voiced.length - 1 ? 3 : 1,
    notes: v.pitches.map((p) => pitchName(p)),
  }));
}

let cache: { rule: ProtoEvent[]; plain: ProtoEvent[] } | null = null;

/** Realized by the voice-leading engine, deterministically, on first use. */
export function ruleOfTheOctave(): { rule: ProtoEvent[]; plain: ProtoEvent[] } {
  if (!cache) cache = { rule: realize(RULE_SYMBOLS), plain: realize(PLAIN_SYMBOLS) };
  return cache;
}
